// NPM
import React, { Component } from 'react';

class RecommendationMatch extends Component {
  render() {
    const { match } = this.props;
    return (
      <div className="RecommendationMatch">
        <div className="RecommendationMatch-bar">
          <div
            className="RecommendationMatch-bar-inner"
            style={{ width: `${match}%` }}
          />
        </div>
        <div className="RecommendationMatch-actions">
          <span className="RecommendationMatch-match">{match}%</span>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default RecommendationMatch;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationMatch.js